import React from 'react';
import { SvgIcon } from '@material-ui/core';

const EditIcon = props => {
  return (
    <SvgIcon {...props}>
      <path d="M12.052,2.495l2.7,2.7a.293.293,0,0,1,0,.413L8.214,12.146l-2.778.308a.582.582,0,0,1-.644-.644L5.1,9.032l6.538-6.538A.293.293,0,0,1,12.052,2.495ZM16.9,1.809,15.44.348a1.171,1.171,0,0,0-1.652,0l-1.06,1.06a.293.293,0,0,0,0,.413l2.7,2.7a.293.293,0,0,0,.413,0l1.06-1.06a1.171,1.171,0,0,0,0-1.652Zm-5.406,8.558v3.047H1.916V3.836H8.795a.368.368,0,0,0,.254-.1l1.2-1.2a.359.359,0,0,0-.254-.614H1.437A1.437,1.437,0,0,0,0,3.357V13.894a1.437,1.437,0,0,0,1.437,1.437H11.974a1.437,1.437,0,0,0,1.437-1.437V9.17a.36.36,0,0,0-.614-.254l-1.2,1.2A.368.368,0,0,0,11.495,10.367Z" />
    </SvgIcon>
  );
};

export default EditIcon;
